import React, { useCallback } from "react"
import { createNativeStackNavigator } from "@react-navigation/native-stack"
import FollowUp from "@Screens/FollowUp/FollowUp"
import { PatientFolder } from "@Screens/FollowUp/PatientFolder/PatientFolder"
import { Goals } from "@Screens/FollowUp/Goals/Goals"
import { GoalDetails } from "@Screens/FollowUp/Goals/GoalDetails"
import { CustomHeaderComponent } from "@Components/CustomHeader/CustomHeaderComponent"
import UserSettingStack from "@Navigation/UserSettingStack/UserSettingStack"
import { EvaluationStack } from "./EvaluationStack"
import { ConstantsFollowUp } from "@Screens/FollowUp/Constants/ConstantsFollowUp"
import { ConstantsFollowUpForm } from "@Screens/FollowUp/Constants/ConstantsFollowUpForm"
import { ConstantsFollowUpChart } from "@Screens/FollowUp/Constants/ConstantsFollowUpChart"
import { ReminderHome } from "@Screens/FollowUp/Reminder/ReminderHome"
import { ReminderForm } from "@Screens/FollowUp/Reminder/ReminderForm"
import { ReportHome } from "@Screens/FollowUp/Reports/ReportHome"
import { ReportDetails } from "@Screens/FollowUp/Reports/ReportDetails"
import { ToolBoxHome } from "@Screens/FollowUp/ToolBox/ToolBoxHome"
import { ToolBoxForm } from "@Screens/FollowUp/ToolBox/ToolBoxForm"
import { ActivityForm } from "@Screens/FollowUp/ToolBox/ActivityForm"
import { ActivityFollowUP } from "@Screens/FollowUp/ToolBox/ActivityFollowUP"
import { AppointmentHome } from "@Screens/FollowUp/Appointment/AppointmentHome"
import { AppointmentForm } from "@Screens/FollowUp/Appointment/AppointmentForm"
import { EvaluationQuizz } from "@Screens/Knowledge/Savoirs/Evaluation/EvaluationQuizz/EvaluationQuizz"
import KnowledgeStack from "@Navigation/KnowledgeStack/KnowledgeStack"
import ConstantCardDetails from "@Screens/FollowUp/Constants/ConstantCardDetails"
import { AppointmentDetails } from "@Screens/FollowUp/Appointment/AppointmentDetails"
import { useRoute } from "@react-navigation/native"
import { AppointmentVisioContent } from "@Screens/FollowUp/Appointment/AppointmentVisioContent"

const MainStackNavigator = createNativeStackNavigator()
export const FollowUpStack = () => {
    const route = useRoute()
    const headerShown = route?.params?.headerShown

    return (
        <MainStackNavigator.Navigator
            screenOptions={{
                headerShown: headerShown ?? true,
                header: (props) => <CustomHeaderComponent {...props} />
            }}
            initialRouteName="FollowUp"
        >
            <MainStackNavigator.Screen name={"FollowUp"} component={FollowUp} />
            {/* <MainStackNavigator.Screen name={"ConstantFollowUpStack"} component={ConstantFollowUpStack} /> */}
            <MainStackNavigator.Screen name={"ConstantFollowUp"} component={ConstantsFollowUp} />
            <MainStackNavigator.Screen name={"ConstantFollowUpForm"} component={ConstantsFollowUpForm} />
            <MainStackNavigator.Screen name={"ConstantFollowUpChart"} component={ConstantsFollowUpChart} />
            <MainStackNavigator.Screen name={"ConstantCardDetails"} component={ConstantCardDetails} />

            <MainStackNavigator.Screen name={"PatientFolder"} component={PatientFolder} />
            <MainStackNavigator.Screen name={"Goals"} component={Goals} />
            <MainStackNavigator.Screen name={"GoalDetail"} component={GoalDetails} />
            {/* <MainStackNavigator.Screen name={"ReminderStack"} component={ReminderStack} /> */}
            <MainStackNavigator.Screen name={"ReminderHome"} component={ReminderHome} />
            <MainStackNavigator.Screen name={"ReminderForm"} component={ReminderForm} />
            {/* <MainStackNavigator.Screen
                options={{ headerShown: false }}
                name={"AppointmentStack"}
                component={AppointmentStack}
            /> */}
            <MainStackNavigator.Screen name={"AppointmentHome"} component={AppointmentHome} />
            <MainStackNavigator.Screen name={"AppointmentForm"} component={AppointmentForm} />
            <MainStackNavigator.Screen name={"AppointmentDetails"} component={AppointmentDetails} />
            {/* <MainStackNavigator.Screen name={"ReportStack"} component={ReportStack} /> */}
            <MainStackNavigator.Screen name={"ReportHome"} component={ReportHome} />
            <MainStackNavigator.Screen name={"ReportDetails"} component={ReportDetails} />
            <MainStackNavigator.Screen name={"EvaluationStack"} component={EvaluationStack} />
            {/* <MainStackNavigator.Screen name={"ToolBoxStack"} component={ToolBoxStack} /> */}
            <MainStackNavigator.Screen name={"ToolBoxHome"} component={ToolBoxHome} />
            <MainStackNavigator.Screen name={"ToolBoxForm"} component={ToolBoxForm} />
            <MainStackNavigator.Screen name={"ActivityForm"} component={ActivityForm} />
            <MainStackNavigator.Screen name={"ActivityFollowUP"} component={ActivityFollowUP} />
            <MainStackNavigator.Screen name="UserSettings" component={UserSettingStack} />
            <MainStackNavigator.Screen name="EvaluationQuizz" component={EvaluationQuizz} />
            <MainStackNavigator.Screen name="Knowledges" component={KnowledgeStack} />
            <MainStackNavigator.Screen name="AppointmentVisioContent" component={AppointmentVisioContent} />
        </MainStackNavigator.Navigator>
    )
}
